import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["for"];
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
const _hoisted_4 = ["id", "aria-label", "title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(_ctx.cls)
    }, [
        (_ctx.label !== '')
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.randomID,
                class: _normalizeClass('form-label mb-0' + (_ctx.disabled ? ' disabled-txt' : '') + (_ctx.useSubLabelFormatting ? ' fst-italic fw-light' : ''))
            }, [
                (_ctx.smallLabel)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_ctx.label), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
            ], 10, _hoisted_1))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            id: _ctx.randomID,
            "aria-label": _ctx.label,
            title: _ctx.label
        }, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 8, _hoisted_4)
    ], 2));
}
